import { render, staticRenderFns } from "./ReporteVentaProductosHora.vue?vue&type=template&id=6f276f26&scoped=true"
import script from "./ReporteVentaProductosHora.vue?vue&type=script&lang=js"
export * from "./ReporteVentaProductosHora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f276f26",
  null
  
)

export default component.exports